/* eslint-disable no-console */
import { GenderEnum } from 'modules/person/enums/GenderEnum'
import { NacionalityEnum } from '../enums/NacionalityEnum'
import { PersonTypeEnum } from '../enums/PersonTypeEnum'

/**
 * UTILITARIOS para entidade Pessoa.
 */
export const PersonUtils = {

    getGenderLabel(gender: GenderEnum): string {
        switch (gender) {
            case GenderEnum.MALE:
                return 'Masculino'
            case GenderEnum.FEMALE:
                return 'Feminino'
            default:
                return 'Outro'
        }
    },

    getNacionalityLabel(nacionality: NacionalityEnum): string {
        switch (nacionality) {
            case NacionalityEnum.FOREIGN:
                return 'Estrangeiro'
            default:
                return 'Brasileiro'
        }
    },

    getPersonTypeLabel(type: PersonTypeEnum): string {
        switch (type) {
            case PersonTypeEnum.PJ:
                return 'Jurídica'
            default:
                return 'Física'
        }
    },

    async getPersonIP(): Promise<string | undefined> {

        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 3000)

        try {
            const response = await fetch('https://api.ipify.org/?format=json', { signal: controller.signal })
            if (!response.ok) {
                console.info('> Erro', response.status, response.statusText)
                return undefined
            }
            const data = await response.json()
            return data?.ip
        } catch (error) {
            console.info('> Falha ao obter IP do usuário', error)
            return undefined
        } finally {
            clearTimeout(timeoutId)
        }
    },

}
